import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationWindowComponent } from './components';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@app/shared/shared.module';
import { effects, reducers } from './store';
import { EffectsModule } from '@ngrx/effects';
import { NotificationContainerComponent } from './containers';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatPaginatorModule } from '@angular/material/paginator';

const NotificationsRouting = RouterModule.forChild([
  {
    path: '',
    component: NotificationContainerComponent,
  },
]);

@NgModule({
  declarations: [NotificationWindowComponent, NotificationContainerComponent],
  imports: [
    NotificationsRouting,
    CommonModule,
    StoreModule.forFeature('notifications', reducers),
    EffectsModule.forFeature(effects),
    TranslateModule,
    MatPaginatorModule,
    SharedModule,
  ],
  exports: [NotificationWindowComponent],
})
export class NotificationsModule {
  constructor() {}
}
